import { zfTranslations } from "./zf_translations";
import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
export class zfc3d {
    static has3DTargets() {
        return ($(".zfc3d-model > .zfc3d-3d-model").length > 0 ||
            $(".zfc3d-model > .zfc3d-canvas").length > 0);
    }
    static prefetchIfPresent() {
        if (!zfc3d.has3DTargets() || zfc3d.photoSpherePrefetchScheduled)
            return;
        zfc3d.photoSpherePrefetchScheduled = true;
        const prefetch = function () {
            zfc3d.ensurePhotoSphereLoaded();
        };
        const requestIdle = window.requestIdleCallback;
        if (typeof requestIdle === "function")
            requestIdle(prefetch);
        else
            setTimeout(prefetch, 0);
    }
    static ensurePhotoSphereLoaded() {
        if (zfc3d.ViewerCtor && zfc3d.MarkersPluginCtor)
            return Promise.resolve(true);
        if (zfc3d.photoSphereLoadPromise)
            return zfc3d.photoSphereLoadPromise;
        zfc3d.photoSphereLoadPromise = Promise.all([
            import("@photo-sphere-viewer/core"),
            import("@photo-sphere-viewer/markers-plugin"),
        ])
            .then(function (modules) {
            var _a, _b;
            const coreModule = modules[0] || {};
            const markersModule = modules[1] || {};
            zfc3d.ViewerCtor =
                coreModule.Viewer || ((_a = coreModule.default) === null || _a === void 0 ? void 0 : _a.Viewer) || coreModule.default;
            zfc3d.MarkersPluginCtor =
                markersModule.MarkersPlugin ||
                    ((_b = markersModule.default) === null || _b === void 0 ? void 0 : _b.MarkersPlugin) ||
                    markersModule.default;
            return !!(zfc3d.ViewerCtor && zfc3d.MarkersPluginCtor);
        })
            .catch(function () {
            zfc3d.photoSphereLoadPromise = undefined;
            return false;
        });
        return zfc3d.photoSphereLoadPromise;
    }
    static init(viewer) {
        zfc3d.ensurePhotoSphereLoaded().then(function (isLoaded) {
            if (!isLoaded)
                return;
            zfc3d.initViewer(viewer);
        });
        return true;
    }
    static initViewer(viewer) {
        const viewerId = viewer.attr("id");
        if (zfc3d.viewers[viewerId])
            return;
        zfc3d.viewers[viewerId] = new zfc3d.ViewerCtor({
            container: viewer.find(".zfc3d-viewer")[0],
            panorama: viewer.data("src"),
            plugins: [[zfc3d.MarkersPluginCtor, {}]],
        });
        zfUtils.displaySpinner();
        $(zfc3d.viewers[viewerId].parent).addClass("zfc3d-loading");
        zfc3d.viewers[viewerId].addEventListener("ready", () => {
            if (typeof viewer.data("markers") != typeof undefined &&
                viewer.data("markers") != false) {
                var count = 0;
                var markersPlugin = zfc3d.viewers[viewerId].getPlugin("markers");
                var btnPart = zfc.btnPartHtml
                    .replace("{{href}}", "{{#ifCond modalId '==' ''}}{{href}}{{/ifCond}}")
                    .replace("{{label}}", "{{{name}}}")
                    .replace("<div class='zfcui-btn {{btnClass}}'", "<button class='zfcui-btn zfccta-button'")
                    .replace("</span> </div> </a> </div>", "</span> </button> </a> </div>")
                    .replace("{{attributes}}", "{{#ifCond modalId '!=' ''}}data-modal-uuid='{{modalId}}'{{/ifCond}} {{#ifCond focus '!=' ''}}data-focus='{{focus}}'{{/ifCond}}");
                var handlebar = zfUtils.handlebarsCompile(btnPart);
                viewer.data("markers").forEach(function (item) {
                    var marker = {
                        id: "text-" + count++,
                        position: {
                            yaw: item.long + "deg",
                            pitch: item.lat + "deg",
                        },
                        html: item.name,
                        className: item.direction == "up" || item.direction.length == 0
                            ? "zfc3d-marker"
                            : "zfc3d-marker zfc3d-marker-down",
                    };
                    marker.html = zfUtils.handlebarsProcessTemplate(handlebar, item);
                    markersPlugin.addMarker(marker);
                });
                var focusMarker = $(viewer).find('.psv-markers .zfccta-button[data-focus="yes"]');
                var focusThisMarker = focusMarker.length > 0
                    ? focusMarker
                        .first()
                        .closest(".zfc3d-marker")
                        .attr("id")
                        .split("psv-marker-")[1]
                    : $(viewer)
                        .find(".psv-markers > .psv-marker")
                        .first()
                        .closest(".zfc3d-marker")
                        .attr("id")
                        .split("psv-marker-")[1];
                markersPlugin.gotoMarker(focusThisMarker, 0);
                $(viewer).find("[data-modal-uuid]").each(zfc.modalize);
                $(".zfc3d-popup-data .zfcacc-item")
                    .find(".zfcsw-wrapper-content")
                    .removeClass("zfc-wrapper-content");
                $(".psv-marker").find("a").removeAttr("href");
                $(".zfc3d-marker .zfcui-btn-wrapper").each(function () {
                    zfc.keyboardEnterToClick($(this));
                });
                zfc.keyboardEnterToClick($(".psv-panel-close-button:first"));
                $(".psv-panel-close-button").attr("tabindex", "0");
                $(".psv-markers-list-button")
                    .off("click.zfc3d")
                    .on("click.zfc3d", function () {
                    $(".psv-panel-menu-item").find("a").removeAttr("href");
                    $('.psv-panel-menu-item a, .psv-panel-menu-item button').attr("tabindex", "-1");
                });
                $(".psv-markers-list-button")
                    .off("keypress.zfc3d")
                    .on("keypress.zfc3d", function (e) {
                    if (e.which == 13) {
                        e.preventDefault();
                        $(".psv-panel-menu-item").find("a").removeAttr("href");
                        $('.psv-panel-menu-item a, .psv-panel-menu-item button').attr("tabindex", "-1");
                    }
                });
            }
            $(zfc3d.viewers[viewerId].parent).removeClass("zfc3d-loading");
            zfUtils.hideSpinner();
        });
    }
    static scrollToPlay(wrapper) {
        var that = $(wrapper).closest(".zfc3d-model > .zfc3d-canvas");
        if (zfc3d.sequenceFocused || zfUtils.inViewport($(wrapper))) {
            var img = Math.ceil((that.find(".zfc3d-scrolltoplay").scrollTop() /
                (that.find(".zfc3d-scroll").height() -
                    that.find(".zfc3d-scrolltoplay").height())) *
                that.data("frames"));
            var scrolled = (img / that.data("frames")) * 100;
            that.find("img.active").removeClass("active");
            if (that.data("frames") > img && img != 0) {
                that.find('img[data-id="' + img + '"]').addClass("active");
            }
            else {
                img == 0
                    ? that.find("img:first").addClass("active")
                    : that.find("img:last").addClass("active");
            }
            that.find(".zfc3d-canvas-progress-bar").css("width", scrolled + "%");
            zfc3d.sequenceTimes[$(that).attr("id")].startTime = new Date().getTime();
            zfc3d.sequenceFocused = false;
        }
        else {
            if (!that.hasClass("autoSkipActive")) {
                var scrollTop = Math.ceil($(wrapper).offset().top - $(".zfch2-header2").height());
                if (scrollTop < 0)
                    scrollTop = 0;
                $([document.documentElement, document.body])
                    .animate({ scrollTop: scrollTop }, "fast")
                    .focus();
                zfc3d.sequenceFocused = true;
            }
            else {
                that.removeClass("autoSkipActive");
            }
        }
    }
    static scrollSkip(id) {
        var that;
        if (id.length) {
            that = $("#" + id);
        }
        else {
            that = $(this).closest(".zfc3d-model > .zfc3d-canvas");
        }
        that.find("img.active").removeClass("active");
        that.find(".zfc3d-image-wrapper > img:last").addClass("active");
        that.find(".zfc3d-canvas-progress-bar").css("width", "0%");
        if (that.find(".zfc3d-scroll").css("display") == "block") {
            that.find(".zfc3d-scroll").css("display", "none");
            that
                .find(".zfc3d-skip > .zfcui-btn-label > span")
                .text(zfTranslations.translations["resume"][document.querySelector("html").lang]);
            that.find(".zfc3d-skip").addClass("zfc3d-resume");
        }
        else {
            that.find(".zfc3d-scroll").css("display", "block");
            that
                .find(".zfc3d-skip > .zfcui-btn-label > span")
                .text(zfTranslations.translations["skip"][document.querySelector("html").lang]);
            that.find(".zfc3d-skip").removeClass("zfc3d-resume");
            zfc3d.sequenceTimes[$(that).attr("id")].startTime = null;
        }
    }
    static lazyLoadImageArr(viewer, imgArr, index) {
        viewer.data("current", index);
        var image = new Image();
        var total = viewer.data("frames");
        zfUtils.displaySpinner();
        image.onload = function () {
            var current = viewer.data("current");
            var percentLoaded = current / total;
            zfUtils.updateProgess(viewer.attr("id"), percentLoaded);
            if (current == total)
                viewer.find(".zfc3d-scrolltoplay").css("display", "block");
            zfUtils.hideSpinner();
            if (current < total)
                zfc3d.lazyLoadImageArr(viewer, imgArr, current + 1);
        };
        image.onerror = function () {
            var current = viewer.data("current");
            var percentLoaded = current / total;
            zfUtils.updateProgess(viewer.attr("id"), percentLoaded);
            if (current == total)
                viewer.find(".zfc3d-scrolltoplay").css("display", "block");
            zfUtils.hideSpinner();
            if (current < total)
                zfc3d.lazyLoadImageArr(viewer, imgArr, current + 1);
        };
        image.setAttribute("data-id", index.toString());
        if (index == 1) {
            image.setAttribute("class", "active");
            image.setAttribute("alt", viewer.data("img-alt"));
        }
        else {
            image.setAttribute("alt", "");
            image.setAttribute("aria-hidden", "true");
        }
        image.src = decodeURIComponent(imgArr[index]);
        var wrapper = $(viewer.find(".zfc3d-image-wrapper"));
        wrapper.append(image);
    }
    static initZFCanvas(viewer) {
        if (viewer.hasClass("initialized"))
            return true;
        var wrapper = $(viewer.find(".zfc3d-image-wrapper"));
        var pattern = viewer.data("pattern");
        var imgCount = viewer.data("frames");
        viewer
            .find(".zfc3d-scrolltoplay .zfc3d-scroll")
            .css("height", imgCount * 6 + "%");
        viewer.find(".zfc3d-scrolltoplay").css("display", "none");
        var imgArr = viewer
            .data("imgs")
            .split(",")
            .sort(function (a, b) {
            return a.match(/[\d]*(?=\.[\D]*$)/) - b.match(/[\d]*(?=\.[\D]*$)/);
        });
        zfUtils.updateProgess(viewer.attr("id"), 0);
        zfc3d.lazyLoadImageArr(viewer, imgArr, 1);
        zfc3d.lazyLoadImageArr(viewer, imgArr, 2);
        zfc3d.lazyLoadImageArr(viewer, imgArr, 3);
        zfc3d.lazyLoadImageArr(viewer, imgArr, 4);
        zfc3d.lazyLoadImageArr(viewer, imgArr, 5);
        zfc3d.lazyLoadImageArr(viewer, imgArr, 6);
        zfc3d.lazyLoadImageArr(viewer, imgArr, 7);
        zfc3d.lazyLoadImageArr(viewer, imgArr, 8);
        zfc3d.lazyLoadImageArr(viewer, imgArr, 9);
        zfc3d.lazyLoadImageArr(viewer, imgArr, 10);
        viewer
            .find(".zfc3d-scrolltoplay")
            .off("scroll.zfc3d")
            .on("scroll.zfc3d", function () {
            zfc3d.scrollToPlay(viewer.find(".zfc3d-scrolltoplay"));
        });
        if (viewer.find(".zfc3d-skip").length)
            viewer
                .find(".zfc3d-skip")
                .off("click.zfc3d")
                .on("click.zfc3d", zfc3d.scrollSkip);
        if (Object.keys(zfc3d.sequenceTimes).length == 0) {
            $(".zfc3d-model > .zfc3d-canvas").each(function () {
                var id = $(this).attr("id");
                zfc3d.sequenceTimes[id] = {
                    startTime: null,
                    expireTime: $(this).data("expiretime") * 1000,
                };
            });
            if (zfc3d.sequenceTimer == null)
                zfc3d.sequenceTimer = setInterval(function () {
                    Object.keys(zfc3d.sequenceTimes).forEach(function (key) {
                        if (zfc3d.sequenceTimes[key].startTime != null) {
                            var skipBtn = $("#" + key).find(".zfc3d-skip");
                            if (new Date().getTime() - zfc3d.sequenceTimes[key].startTime >=
                                zfc3d.sequenceTimes[key].expireTime) {
                                if (!skipBtn.hasClass("zfc3d-resume") &&
                                    skipBtn.hasClass("zfc3d-skip")) {
                                    $("#" + key).addClass("autoSkipActive");
                                    zfc3d.scrollSkip(key);
                                }
                                zfc3d.sequenceTimes[key].startTime = null;
                            }
                        }
                    });
                }, 5000);
        }
        viewer.addClass("initialized");
        return true;
    }
}
zfc3d.viewers = {};
zfc3d.sequenceFocused = false;
zfc3d.sequenceTimes = {};
zfc3d.sequenceTimer = null;
zfc3d.photoSpherePrefetchScheduled = false;
try {
    zfUtils.onReady(function () {
        zfc3d.prefetchIfPresent();
        $(".zfc3d-model > .zfc3d-3d-model").each(function () {
            if ($(this).closest(".zfcgs-general-slider").length == 0) {
                zfUtils.loadOnScroll($(this), "delayZFC3DLoad", zfc3d.init, 3);
            }
        });
        $(".zfc3d-model > .zfc3d-canvas").each(function (index) {
            if ($(this).closest(".zfcgs-general-slider").length == 0) {
                var that = $(this);
                setTimeout(function () {
                    zfUtils.loadOnScroll(that, "delayZFC3DCanvasLoad", zfc3d.initZFCanvas, 3);
                }, 1000 * (index + 1));
            }
        });
    });
}
catch (err) {
    console.log("Initalization failed: zfc3d.init() " + err.message);
}
